.has-stripe-logo {
    background-size: cover;
    background-position: center;
    width: 62px;
    height: 37px;
    background-image: url('./stripe.png');
}